/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  JOB_POSTING_SECTION_TITLE_REND: null,
  JOB_POSTING_FORM_TITLE_REND: null,
  JOB_POSTING_FORM_CONTAINER_REND: null,
  JOB_POSTING_INTRO_HEADING_REND: null,
  JOB_POSTING_INTRO_DESC_REND: null,
  JOB_POSTING_INFO_CONTAINER_REND: null
});
